<template>
  <div class="white_loader"></div>
</template>

<script>
export default {
  name: "WhiteLoader"
};
</script>

<style lang="scss" scoped>
.white_loader {
  width: 30px;
  height: 30px;
  margin: 0 auto;
  border-left: 5px solid #dcdcdc;
  border-top: 5px solid #dcdcdc;
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-radius: 60px;
  animation: spin 0.3s infinite linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
